<template>
    <div class="visitSubmission">
        <!-- <van-nav-bar fixed>
            <div slot="left" @click="close">
                <van-icon name="arrow-left" color="#2980FE" size="19" />
            </div>
        </van-nav-bar> -->
        <div class="visitSubmission-content">
            <div class="visitSubmission-img">
                <van-image width="178" height="153"  :src="require('@/assets/operationalAnalysis/visit-approval-success.png')" fit="cover" />
            </div>
            <div class="visitSubmission-text">
                <div v-if="vTitle" class="visitSubmission-title">{{vTitle}}</div>
                <div v-if="vText" class="visitSubmission-title-text">{{vText}}</div>
            </div>
            <div class="visitSubmission-text-t" v-if="queryphone && queryIdCard && !queryIsManyTimes">
                 <div class="visitSubmission-title-text">用户名：{{queryphone}}</div>
                <div class="visitSubmission-title-text">密码：XY{{queryIdCard.slice(queryIdCard.length-6)}}</div>
            </div>
            <van-button v-if="btnText" round type="info" plain class="button-detail" @click="onVisitList">{{btnText}}</van-button>
        </div>
    </div>
</template>
<script>
export default {
    name:'VisitSubmission',
    props:{
        vTitle:{
            type:String,
            required: true
        },
        vText:{
            type:String,
            required: true
        },
        btnText:{
            type:String,
            required: true
        },
        queryphone:{
            type:String,
            required: true
        },
        queryIdCard:{
            type:String,
            required: true
        },
        queryIsManyTimes:{
            type:Boolean,
            required:true
        }
    },
    methods:{
        // close(){
        //     this.$router.go(-1)
        // },
        onVisitList(){
            this.$emit('onVisitList')
        }
    }
}
</script>
<style lang="less" scoped>
.visitSubmission{
    .visitSubmission-content{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 20%;
        .visitSubmission-img{
            border: 2px dashed #cccccc;
        }
        .visitSubmission-text{
            margin-top: 40px;
            text-align: center;
            .visitSubmission-title{
                font-size: 36px;
                font-weight: bold;
            }
            .visitSubmission-title-text{
                margin-top: 10px;
                font-size: 26px;
                color: #cccccc;
            }
        }
        .visitSubmission-text-t{
            text-align: left;
            .visitSubmission-title-text{
                text-align: center;
                color: #4196ff;
                margin-top: 10px;
                font-size: 26px;
            }
        }
        .button-detail{
            margin-top: 10%;
            width: 280px;
        }
    }
}
</style>